import { Phone, Mail, MapPin } from 'lucide-react'
import { Link } from 'react-router-dom'
import { siteData, navLinks } from '../../data/siteData'

export default function Footer() {
  return (
    <footer className="relative bg-section-dark border-t border-military/20" style={{ backgroundColor: 'rgba(10,14,10,0.7)', backdropFilter: 'blur(2px)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/images/logo.png"
                alt="Strefa TOP"
                className="w-16 h-16"
              />
              <div>
                <span className="font-display text-xl text-bone tracking-wider">STREFA TOP</span>
                <p className="font-mono text-[10px] text-chrome tracking-[0.2em] uppercase">
                  ASG & Paintball
                </p>
              </div>
            </div>
            <p className="font-body text-sm text-chrome leading-relaxed">
              {siteData.tagline}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-subheading font-bold text-bone uppercase tracking-wider mb-4">
              Nawigacja
            </h4>
            <ul className="space-y-2">
              {navLinks.map((link) => {
                const to = link.href.startsWith('/') ? link.href : '/' + link.href
                return (
                  <li key={link.href}>
                    <Link
                      to={to}
                      className="font-body text-sm text-chrome hover:text-military-light transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-subheading font-bold text-bone uppercase tracking-wider mb-4">
              Kontakt
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  href={`tel:${siteData.phone}`}
                  className="flex items-center gap-2 font-body text-sm text-chrome hover:text-military-light transition-colors"
                >
                  <Phone size={14} />
                  {siteData.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${siteData.email}`}
                  className="flex items-center gap-2 font-body text-sm text-chrome hover:text-military-light transition-colors"
                >
                  <Mail size={14} />
                  {siteData.email}
                </a>
              </li>
              <li>
                <span className="flex items-center gap-2 font-body text-sm text-chrome">
                  <MapPin size={14} />
                  {siteData.address}
                </span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-subheading font-bold text-bone uppercase tracking-wider mb-4">
              Social media
            </h4>
            <div className="flex flex-wrap gap-2">
              {Object.entries(siteData.social).map(([name, url]) => (
                <a
                  key={name}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-3 py-1.5 bg-steel-lighter border border-military/20 rounded-sm font-mono text-xs text-chrome hover:text-bone hover:border-military-light transition-colors capitalize"
                >
                  {name}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-military/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="font-mono text-xs text-chrome/60">
              © 2025 Strefa TOP. Wszelkie prawa zastrzeżone.
            </p>
            <div className="flex items-center gap-1">
              <span className="font-mono text-[10px] text-chrome/40 uppercase tracking-wider">
                Made with
              </span>
              <span className="text-military-light">♥</span>
              <span className="font-mono text-[10px] text-chrome/40 uppercase tracking-wider">
                in Tarnów Opolski
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
